
import MarketShareSettingsService from './MarketShareSettingsService';

export { default } from './MarketShareSettingsService';
export const marketShareSettingsService = new MarketShareSettingsService();